module.exports = __webpack_public_path__ + "static/media/mapActive.2e7dcdc2.svg";